// Evidence Feedback API functions
import { scribeHttpV2 } from '@/utils/scribeHTTP';

const BASE_PATH = '/evidence/feedback';

export interface CreateEvidenceFeedbackRequest {
  /** Ease rating (UMUX-Lite) 1–5 */
  ease_stars: number;
  /** Usefulness rating (UMUX-Lite) 1–5 */
  usefulness_stars: number;
  /** Optional free-text feedback: "How could we improve Evidence for you?" */
  feedback?: string;
  /**
   * Legacy single star rating. Only sent by older clients for backward
   * compatibility; UMUX-Lite submissions should omit this field.
   */
  stars?: number;
}

export interface CreateEvidenceFeedbackResponse {
  /** Whether the feedback was saved successfully */
  success: boolean;
  /** ID of the created feedback record */
  feedback_id: string;
  /** Updated count of feedback submissions for the user */
  evidence_general_feedback_count: number;
}

export interface SnoozeEvidenceFeedbackResponse {
  /** Whether the snooze was recorded successfully */
  success: boolean;
  /** Updated snooze count (1-3, after 3 the nudge is permanently dismissed) */
  snooze_count: number;
}

/**
 * Submit general feedback for the Evidence feature.
 * This stores the feedback in the backend and tracks to PostHog.
 *
 * @param request - The feedback data (stars 1-5, optional text)
 * @returns The created feedback record info
 */
export async function submitEvidenceFeedback(
  request: CreateEvidenceFeedbackRequest
): Promise<CreateEvidenceFeedbackResponse> {
  const response = await scribeHttpV2.post<CreateEvidenceFeedbackResponse>(
    BASE_PATH,
    request
  );
  return response.data;
}

/**
 * Snooze the experience feedback nudge.
 * Called when user clicks "Maybe later" on the feedback prompt.
 * After 3 snoozes, the nudge will never show again.
 *
 * @returns The updated snooze count
 */
export async function snoozeEvidenceFeedback(): Promise<SnoozeEvidenceFeedbackResponse> {
  const response = await scribeHttpV2.post<SnoozeEvidenceFeedbackResponse>(
    `${BASE_PATH}/snooze`
  );
  return response.data;
}
